import React, { useCallback } from 'react';
import Checkbox from './Checkbox';
import _ from 'lodash';
import { applyMultipleChoiceValue } from 'common-data-handling';

const MultipleChoice = (props) => {
    const { onChange, value: checkedValues, options, maxOptions, checkboxColor, checkboxBackground } = props;

    const handleChange = useCallback(
        (value, checked) => {
            onChange(
                applyMultipleChoiceValue(checkedValues, value, checked, {
                    maxOptions,
                    validOptions: options.map((o) => o.value),
                })
            );
        },
        [onChange, checkedValues, maxOptions, options]
    );

    return (
        <div>
            {options.map((option, i) => {
                return (
                    <Checkbox
                        className="block"
                        color={checkboxColor}
                        key={i}
                        checked={_(checkedValues).includes(option.value)}
                        onChange={(checked) => handleChange(option.value, checked)}
                        style={{
                            color: checkboxColor,
                            backgroundColor: checkboxBackground,
                        }}>
                        {option.label}
                    </Checkbox>
                );
            })}
        </div>
    );
};

export default MultipleChoice;
